var trailSlider = document.getElementById("trail-length");

document.body.addEventListener("touchstart", (event) => {
    event.preventDefault();
}, { capture: true, passive: true });

document.addEventListener("pointermove", (e) => {
    var trailParticle = document.createElement('div');

    trailParticle.setAttribute('class', 'trail');

    trailParticle.style.left = (e.clientX) + "px";
    trailParticle.style.top = (e.clientY) + "px";
    trailParticle.style.pointerEvents = "none";
    trailParticle.style.setProperty("--trail-length", "disappear " + trailSlider.value + "s");

    trailParticle.onanimationend = () => {
        trailParticle.remove();
    }

    document.body.insertAdjacentElement('beforeend', trailParticle);
});